import { render, staticRenderFns } from "./assignmentComponent.vue?vue&type=template&id=a7f4cf5a&"
import script from "./assignmentComponent.vue?vue&type=script&lang=js&"
export * from "./assignmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports